<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="feature-content">
	<h1>
		{{locoLabel?.features}}</h1>
	<ul>
		<li *ngFor='let feature of listOfFeature'>{{feature.featureDescription}}</li>
	</ul>
	<div class="clearfix"></div>
</div>